import { Dispatch } from '@reduxjs/toolkit';
import { injectReducer } from 'ducks/configureStore';
import { Feature, ShouldReset } from '../../../../features/Feature';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ducks';

export type AutofillState = {
  autofillActive: boolean;
  autoFillDepth: number;
  showAutofillCollisionWarningSheet: boolean;
};

const initialState: AutofillState = {
  autofillActive: false,
  showAutofillCollisionWarningSheet: false,
  autoFillDepth: 550
};

type ExtendedRootState = RootState & {
  autofill: AutofillState;
};

const AutofillSlice = createSlice({
  name: 'AutofillSlice',
  initialState,
  reducers: {
    setAutofillActive(state, action: PayloadAction<boolean>) {
      state.autofillActive = action.payload;
    },
    setAutoFillDepth(state, action: PayloadAction<number>) {
      state.autoFillDepth = action.payload;
    }
  }
});

export const isAutofillActive = (state: ExtendedRootState) => state.autofill.autofillActive;
export const AutofillCollisionWarningSheetVisible = (state: ExtendedRootState) =>
  state.autofill.showAutofillCollisionWarningSheet;
export const autoFillDepth = (state: ExtendedRootState) => state.autofill.autoFillDepth;

export const { setAutofillActive, setAutoFillDepth } = AutofillSlice.actions;

export class Autofill extends Feature implements ShouldReset {
  protected init(): void {
    injectReducer<AutofillState>('autofill', AutofillSlice.reducer);
  }

  reset(dispatch: Dispatch) {
    dispatch(setAutofillActive(false));
  }
}
